import React from 'react';

import { Queries } from '@/queries/Queries.ts';
import { CardContent } from '@/uiKit/atoms/card/CardContent.tsx';
import { DiabetesTypeSelectionField } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/DiabetesTypeSelectionField.tsx';
import { HealthCareProviderSelectionField } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/HealthCareProviderSelectionField.tsx';
import { InsulinSchemeSelectionField } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/InsulinSchemeSelectionField.tsx';
import { NoInsulinGestationalWarning } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/NoInsulinGestationalWarning.tsx';
import { SupportedInsulinPumpInfoBox } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/SupportedInsulinPumpInfoBox.tsx';
import { TelemonitoringCriteriaSelectionField } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/TelemonitoringCriteriaSelectionField.tsx';
import { TelemonitoringDescriptionField } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/TelemonitoringDescriptionField.tsx';
import { TelemonitoringDurationField } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/TelemonitoringDurationField.tsx';
import { TermDateField } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/FormFields/TermDateField.tsx';

export type CarePlanCreationFormContentProps = {
  patientInfo: {
    givenName: string;
    familyName: string;
  };
};

export const CarePlanCreationFormContent: React.FC<
  CarePlanCreationFormContentProps
> = ({ patientInfo }) => {
  const carePlanDirectives = Queries.practitioner.useCarePlanDirectives({});
  const providers = Queries.practitioner.useHSPList({});

  return (
    <CardContent>
      <DiabetesTypeSelectionField
        allowedDiabetesTypes={carePlanDirectives.allowedDiabetesTypes}
      />
      <InsulinSchemeSelectionField
        allowedInsulinSchemes={carePlanDirectives.allowedInsulinScheme}
      />
      <SupportedInsulinPumpInfoBox />
      <TelemonitoringCriteriaSelectionField
        carePlanDirectives={carePlanDirectives}
        telemonitoringTierRestrictions={carePlanDirectives.restrictions}
      />
      <TelemonitoringDurationField />
      <HealthCareProviderSelectionField providers={providers} />
      <TelemonitoringDescriptionField patientInfo={patientInfo} />
      <TermDateField />
      <NoInsulinGestationalWarning />
    </CardContent>
  );
};
